import {
    Injectable,
    Injector,
    inject
} from "@angular/core";

import {
    EntityHook,
    OfflineFirstEntity
} from "../entity.model";

import {
    SaleTransactions
} from "tilby-models";

import { 
    EntityManagerService
} from "src/app/core";

@Injectable({
    providedIn: 'root'
})
export class SaleTransactionsEntityHook implements EntityHook {
    private readonly injector = inject(Injector);

    public async createOfflineBeforeStorage(entityId: string | number, entityData: SaleTransactions) {
        //Disable this hook if the transaction is not auto-generated
        if(!entityData.autogenerated) {
            return;
        }

        //Avoid overriding an already printed transaction
        if(entityData.printed || entityData.skip_printing) {
            return;
        }

        const previousEntity = await this.injector.get(EntityManagerService).saleTransactions.fetchOneOffline(entityId);

        if(previousEntity?.printed || previousEntity?.skip_printing) {
            return { overrideReturnValue: previousEntity };
        }
    }

    public async createOfflineAfterStorage(entityId: string | number, entityData: SaleTransactions) {
        //If the transaction is auto-generated, remove the locally-created placeholder transaction if it exists
        if(entityData.autogenerated && (entityData.uuid !== entityData.id as any)) {
            const entityManagerService = this.injector.get(EntityManagerService);
            
            //Get the current placeholder transaction
            const placeholderTransaction = await entityManagerService.saleTransactions.fetchOneOffline(entityData.uuid) as OfflineFirstEntity<SaleTransactions>;

            //If the placeholder transaction is not dirty, don't delete it as needs to be synced
            if(!placeholderTransaction?.dirty) {
                await entityManagerService.saleTransactions.deleteOneOffline(entityData.uuid);
            }
        }
    }
}